import { tagsView } from '@/settings'

const state = {
    width: '',
    height: '',
    navbarHeight: 50,
    tagsViewHeight: tagsView ? 34 : 0
}

const mutations = {
  MODIFY_SCREEN: (state) => {
    state.width = window.document.body.clientWidth
    state.height = window.document.body.clientHeight
  }
}

const actions = {
  modifyScreen({ commit }) {
    commit('MODIFY_SCREEN')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

